<template>
  <vonap-promised :promise="promise">
    <vonap-window
      ref="window"
      :width="'600px;'"
      title="Counterparty"
      :visible="true"
      style="display:none"
      @cancel="cancel"
      @close="cancel"
      :modal="true"
    >
      <v-form ref="editForm" @submit.prevent="save">
        <div class="row">
          <div class="col-md-6">
            <div class="row">
              <div class="col-xs-12">
                <section v-show="!isMaster">
                  <v-combobox
                    v-model="selectedItem"
                    :items="comboItems"
                    @change="comboChanged"
                    item-text="code"
                    item-value="counterpartyId"
                    :rules="[v => !!v || 'Code is required!']"
                    :label="labelText"
                    :disabled="!isNew"
                  >
                  </v-combobox>
                </section>
                <section v-show="isMaster">
                  <v-text-field
                    label="Code"
                    v-model="model.code"
                    required
                    :rules="[v => !!v || 'Code is required!']"
                  >
                  </v-text-field>
                </section>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <v-select
                  label="Curve"
                  :items="curveItems"
                  item-text="curveName"
                  item-value="curveId"
                  v-model="model.curveId"
                  width="50"
                >
                </v-select>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <v-text-field
                  label="Description"
                  v-model="model.description"
                  required
                  :rules="[v => !!v || 'Description is required!']"
                >
                </v-text-field>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <v-text-field label="Limit" type="number" v-model="model.limit"> </v-text-field>
              </div>
            </div>
            <div class="row" v-show="!isMaster">
              <div class="col-xs-12">
                <v-text-field
                  label="Future Contract Commission"
                  type="number"
                  v-model="model.futureContractCommission"
                >
                </v-text-field>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-xs-12">
                <v-text-field label="Phone" v-model="model.phoneNumber"> </v-text-field>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <v-text-field label="Email" type="email" v-model="model.email"> </v-text-field>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12">
                <v-textarea label="Address" v-model="model.address" rows="8"></v-textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-12" style="text-align: right;">
          <v-btn color="blue primary" @click="save">Save</v-btn>
        </div>
      </v-form>
    </vonap-window>
  </vonap-promised>
</template>

<script>
import axios from 'axios'
import notification from '@/helpers/notification'
import VonapWindow from '../../../components/VonapWindow'
import VonapPromised from '@/components/VonapPromised'
import {mapGetters} from 'vuex'
export default {
  props: {
    model: Object,
    marketId: {
      type: String,
      default: null,
    },
  },
  components: {
    VonapWindow,
    VonapPromised,
  },
  async mounted() {
    const {data} = await axios.get('/api/config/counterparty/getCreditCurve')
    this.curveItems = data
  },
  data() {
    return {
      itemFound: false,
      curveItems: [],
      comboItems: {},
      selectedItem: {
        counterpartyId: 0,
        code: 'Select one',
      },
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    promise() {
      return this.getData()
    },
    labelText() {
      return this.isNew ? 'Select an existing or type a new code' : 'Code'
    },
    isMaster() {
      return this.clientId == 0
    },
    isNew() {
      return this.model.counterpartyId == 0
    },
  },
  methods: {
    comboChanged(e) {
      const code = typeof e == 'string' ? e : e.code

      const item = this.findComboItem(code)
      if (item) {
        this.itemFound = true
        this.model.phoneNumber = item.phoneNumber
        this.model.description = item.description
        this.model.email = item.email
        this.model.address = item.address
        this.model.curveId = item.curveId
        this.model.code = item.code
        this.model.counterpartyId = item.counterpartyId
      } else {
        this.itemFound = false
        this.model.code = code
        this.model.phoneNumber = null
        this.model.description = null
        this.model.email = null
        this.model.address = null
        this.model.curveId = null
        this.model.counterpartyId = 0
      }
    },
    findComboItem(code) {
      const item = this.comboItems.find(item => item.code.toUpperCase() == code.toUpperCase())
      return item
    },
    cancel() {
      this.$emit('cancel')
    },
    async getData() {
      const {data} = await axios.get('/api/config/counterparty/getComboData', {
        params: {
          clientId: this.clientId,
          marketId: this.marketId,
        },
      })
      this.comboItems = data
      if (!this.isNew && !this.isMaster) {
        this.selectedItem.code = this.model.code
        this.selectedItem.counterpartyId = this.model.counterpartyId
      }
    },
    async save() {
      if (this.$refs.editForm.validate()) {
        const data = this.isNew
          ? await axios
              .post('/api/config/counterparty/save', {
                model: this.model,
                clientId: this.clientId,
                marketId: this.marketId,
              })
              .catch(x => notification(x, 'error'))
          : await axios
              .put('/api/config/counterparty/update', {
                model: this.model,
                clientId: this.clientId,
                marketId: this.marketId,
              })
              .catch(x => notification(x, 'error'))

        if (data.data.error) {
          notification(data.data.error, 'error')
        }
        this.$emit('save')
      }
    },
  },
}
</script>
